// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthenticatedLayout_containerLayout__COR34 {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.AuthenticatedLayout_containerLayout__COR34 main {
  flex: 1 1;
}

.AuthenticatedLayout_borderLine__fMIGQ {
  border: 1px solid var(--color-fondo-claro);
  width: 100%;
}

@media (min-width: 2560px) {
  .AuthenticatedLayout_customContainer__vkI-C {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.AuthenticatedLayout_whatsappFloat__4pjR4 {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 9999;
  width: 43px;
  height: 43px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #25d366;
  color: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  text-decoration: none;
}
.AuthenticatedLayout_whatsappFloat__4pjR4 svg {
  width: 28px;
  height: 28px;
}
.AuthenticatedLayout_whatsappFloat__4pjR4:hover {
  filter: brightness(0.95);
  transform: translateY(-1px);
}
.AuthenticatedLayout_whatsappFloat__4pjR4:active {
  transform: translateY(0px);
}

.AuthenticatedLayout_trustSection__uBkx\\+ {
  min-height: 120px;
}

.AuthenticatedLayout_newsletterSection__rz5CH {
  min-height: 160px;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/AuthenticatedLayout/AuthenticatedLayout.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AACJ;AACI;EACI,SAAA;AACR;;AAGA;EACI,0CAAA;EACA,WAAA;AAAJ;;AAGA;EACI;IACI,iBAAA;IACA,cAAA;EAAN;AACF;AAGA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EAEA,WAAA;EACA,YAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,WAAA;EACA,0CAAA;EAEA,qBAAA;AALJ;AAOI;EACI,WAAA;EACA,YAAA;AALR;AAQI;EACI,wBAAA;EACA,2BAAA;AANR;AASI;EACI,0BAAA;AAPR;;AAWA;EACI,iBAAA;AARJ;;AAWA;EACI,iBAAA;AARJ","sourcesContent":[".containerLayout {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n\n    main {\n        flex: 1;\n    }\n}\n\n.borderLine {\n    border: 1px solid var(--color-fondo-claro);\n    width: 100%;\n}\n\n@media (min-width: 2560px) {\n    .customContainer {\n        max-width: 1920px;\n        margin: 0 auto;\n    }\n}\n\n.whatsappFloat {\n    position: fixed;\n    right: 18px;\n    bottom: 18px;\n    z-index: 9999;\n\n    width: 43px;\n    height: 43px;\n    border-radius: 999px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background: #25d366;\n    color: #fff;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n\n    text-decoration: none;\n\n    svg {\n        width: 28px;\n        height: 28px;\n    }\n\n    &:hover {\n        filter: brightness(0.95);\n        transform: translateY(-1px);\n    }\n\n    &:active {\n        transform: translateY(0px);\n    }\n}\n\n.trustSection {\n    min-height: 120px;\n}\n\n.newsletterSection {\n    min-height: 160px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerLayout": `AuthenticatedLayout_containerLayout__COR34`,
	"borderLine": `AuthenticatedLayout_borderLine__fMIGQ`,
	"customContainer": `AuthenticatedLayout_customContainer__vkI-C`,
	"whatsappFloat": `AuthenticatedLayout_whatsappFloat__4pjR4`,
	"trustSection": `AuthenticatedLayout_trustSection__uBkx+`,
	"newsletterSection": `AuthenticatedLayout_newsletterSection__rz5CH`
};
export default ___CSS_LOADER_EXPORT___;
